import { useState } from 'react'
import { ModalStore } from '../../state/ModalStore'
import { CallAction } from '../Buttons/CallAction'
import { CheckIcon } from '@heroicons/react/outline'
// import { log } from '../../helpers/utils'
import HelperText from './HelperText'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { selectTemplateField } from '../../helpers/slug'

function ChooseModalField({
    item,
    getValues,
    templates_and_attributes,
    setValue,
    errors,
    ...props
}) {
    const addModal = ModalStore((state) => state.add)

    const [hasSelected, setHasSelected] = useState(false)
    const router = useRouter()

    const afterSelection = (value) => {
        if (value) {
            setHasSelected(true)
        }
    }

    const handleClick = () => {
        const Component = item.modal

        // log('ChooseModalField', item)

        addModal(
            <Component
                {...{
                    templates_and_attributes,
                    setValue,
                    getValues,
                    item,
                    afterSelection,
                    ...props,
                }}
            />,
        )
    }

    useEffect(() => {
        if (router.query?.template && router.query?.templateName) {
            console.log(
                'Selecting template',
                selectTemplateField.name === item.name,
                item,
            )
            // const template = { url: router.query?.template, name: router.query?.templateName }
            if (selectTemplateField.name === item.name) {
                console.log('Selecting template', router.query)
                handleClick()
            }
        }
    }, [router.query])

    const isDesignFilesField = item?.name?.includes('Logo')
    const selectedFiles = getValues?.(item.name)
    const designFiles = Array.isArray(selectedFiles) ? selectedFiles : []

    return (
        <div className={isDesignFilesField ? 'py-2' : 'py-2'}>
            {isDesignFilesField ? (
                <>
                    <label className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.04em] text-gray-500">
                        Your files
                    </label>
                    <button
                        type="button"
                        onClick={handleClick}
                        data-button-id={props['data-button-id']}
                        className={`inline-flex w-full items-center justify-center gap-2 rounded-full border-[1.5px] px-[22px] py-3 text-[14.5px] font-semibold transition-all duration-150 active:translate-y-[1px]
                            ${
                                errors?.[item.name]
                                    ? 'border-red-500'
                                    : 'border-[#F6D9C2]'
                            }
                            bg-white text-[#ED5C2F] hover:bg-[#FDF4EC] focus:border-[#F28230] focus:outline-none focus:ring-4 focus:ring-[#F28230]/15
                        `}>
                        <span>+ Select design files</span>
                        {hasSelected && <CheckIcon className="h-4 w-4" />}
                    </button>
                    {item?.description && (
                        <p className="mt-2 text-[12px] leading-[1.5] text-gray-500">
                            {item.description}
                        </p>
                    )}
                    {designFiles.length > 0 && (
                        <div className="mt-2 space-y-2">
                            {designFiles.map((file, index) => {
                                const stringValue =
                                    typeof file === 'string' ? file : null
                                const displayName =
                                    file?.name ||
                                    file?.path ||
                                    (typeof stringValue === 'string'
                                        ? stringValue.split('/').pop()
                                        : '') ||
                                    (typeof file?.url === 'string'
                                        ? file.url.split('/').pop()
                                        : `Design file ${index + 1}`)

                                return (
                                    <div
                                        key={file?.url || file?.name || index}
                                        className="flex items-center gap-[9px] rounded-[9px] border border-[#E1DACE] bg-white px-3 py-[9px] text-[13.5px] text-[#1A1D23]">
                                        <span className="font-bold text-[#2E9E6B]">
                                            ✓
                                        </span>
                                        <span className="min-w-0 flex-1 truncate">
                                            {displayName}
                                        </span>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </>
            ) : (
                <>
                    <CallAction
                        onClick={handleClick}
                        {...props}
                        className={`w-full flex justify-center items-center space-x-2 font-medium
                            ${
                                errors?.[item.name]
                                    ? 'border-red-500'
                                    : 'border-transparent'
                            }
                            border
                        `}>
                        <span>{item?.label || item.name}</span>
                        {hasSelected && (
                            <CheckIcon className="w-4 h-4 font-medium" />
                        )}
                    </CallAction>

                    {item?.description && (
                        <HelperText>{item?.description}</HelperText>
                    )}
                </>
            )}
        </div>
    )
}

export default ChooseModalField
